import { isZeroDate } from '@/services/date'

export const initGetEventResp = (event) => {
  if (!event) return event
  const data = { ...event }
  data.dateStart = new Date(data.dateStart)
  data.dateEnd = new Date(data.dateEnd)

  // eslint-disable-next-line no-use-before-define
  data.period = getEventPeriod(data.dateStart, data.dateEnd)

  if (data.attendees) {
    data.attendees = data.attendees.map((a) => {
      // eslint-disable-next-line no-param-reassign
      a.checkedInAt = new Date(a.checkedInAt)
      // eslint-disable-next-line no-param-reassign
      a.checkedIn = !!isZeroDate(a.checkedInAt)
      return a
    })
  }

  return data
}

const getEventPeriod = (dateStart, dateEnd) => {
  if (dateEnd < new Date()) return 'past'
  if (new Date() < dateStart) return 'future'
  return 'now'
}

export const initUpdateEventReq = (event) => {
  if (!event) return event
  const data = { ...event }
  const isSameDay = new Date(data.dateStart).getDate() === new Date(data.dateEnd).getDate()
  const dateOptions = { year: 'numeric', month: 'short', day: 'numeric' }
  const timeOptions = { hour: '2-digit', minute: '2-digit' }

  // Apr 5, 2023 - Apr 8, 2023
  data.dateFlat = isSameDay
    ? new Date(data.dateStart).toLocaleDateString('en-US', dateOptions)
    : `${new Date(data.dateStart).toLocaleDateString('en-US', dateOptions)} - ${new Date(
        data.dateEnd
      ).toLocaleDateString('en-US', dateOptions)}`

  // 10:00 AM - 5:00 PM
  data.timeFlat = `${new Date(data.dateStart).toLocaleTimeString('en-US', timeOptions)} - ${new Date(
    data.dateEnd
  ).toLocaleTimeString('en-US', timeOptions)}`
  data.dateEnd = new Date(data.dateEnd).toISOString()
  data.dateStart = new Date(data.dateStart).toISOString()

  return data
}

export const initBattleResp = (battle) => {
  if (!battle) return battle
  // eslint-disable-next-line no-param-reassign
  battle.startDate = new Date(battle.startDate)

  // eslint-disable-next-line max-len,no-param-reassign
  battle.permissions.registerButtonVisible = !!Object.keys(battle.permissions).filter(
    (pkey) => battle.permissions[pkey]
  ).length

  if (battle.crews.length) {
    // eslint-disable-next-line no-param-reassign,no-use-before-define
    battle.crews = initBattleCrews(battle.crews)
    // eslint-disable-next-line no-param-reassign,no-use-before-define
    battle.waitList = initBattleCrews(battle.waitList)
  }

  if (battle.participants.length) {
    // eslint-disable-next-line no-param-reassign,no-use-before-define
    battle.participants = initBattleParticipants(battle.participants)
    // eslint-disable-next-line no-param-reassign,no-use-before-define
    battle.waitList = initBattleParticipants(battle.waitList)
  }

  if (battle.orgLegalDocs) {
    // eslint-disable-next-line no-param-reassign
    battle.orgLegalDocs.waiverSignedAt = new Date(battle.orgLegalDocs.waiverSignedAt)
    // eslint-disable-next-line no-param-reassign
    battle.orgLegalDocs.agreementSignedAt = new Date(battle.orgLegalDocs.agreementSignedAt)
  }

  return battle
}

export const initUpdateBattleReq = (battle) => {
  if (!battle) return battle
  const data = { ...battle }
  data.startDate = new Date(data.startDate).toISOString()
  return data
}

export const initPrelimsResp = (prelims) => {
  // If there are no crews in the prelims, we need to add empty 1 round
  if (prelims?.crews) {
    // eslint-disable-next-line no-param-reassign
    prelims.crews = prelims.crews.map((crew) => {
      // eslint-disable-next-line no-param-reassign
      if (!Object.keys(crew.prelims.rounds).length) crew.prelims.rounds = { 1: [] }

      return crew
    })
  }

  // If there are no participants in the prelims, we need to add empty 0 round
  if (prelims?.participants) {
    // eslint-disable-next-line no-param-reassign
    prelims.participants = prelims.participants.map((p) => {
      // eslint-disable-next-line no-param-reassign
      if (!Object.keys(p.prelims.rounds).length) p.prelims.rounds = { 0: [] }

      return p
    })
  }

  return prelims
}

export const initTickets = (tickets) =>
  tickets.map((t) => {
    const ticket = { ...t }

    ticket.taxes /= 100
    ticket.ticketTaxes = ticket.taxes.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

    ticket.fees /= 100
    ticket.ticketFees = ticket.fees.toLocaleString('en-US', { style: 'currency', currency: 'USD' })

    ticket.sum /= 100
    ticket.ticketSum = ticket.sum.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
    return ticket
  })

const initBattleCrews = (crews) =>
  crews.map((crew) => {
    // eslint-disable-next-line no-param-reassign,no-use-before-define
    crew.participants = initBattleParticipants(crew.participants)
    // crew.judging = crew.judging.map(j => {
    //   j.withStar = j.points % 1 !== 0
    //   return j
    // })

    return crew
  })

// TODO: remove this function and place the logic on backend part
export const initBattleParticipants = (participants) =>
  participants.map((p) => ({
    ...p,
    checkedIn: !!isZeroDate(p.checkedInAt),
    checkedInAt: new Date(p.checkedInAt),
    confirmed: !!isZeroDate(p.confirmedAt),
    confirmedAt: new Date(p.confirmedAt),
    waiverSigned: p.waiverSignedAt ? !!isZeroDate(p.waiverSignedAt) : false,
    waiverSignedAt: p.waiverSignedAt ? new Date(p.waiverSignedAt) : null,
    agreementSigned: p.agreementSignedAt ? !!isZeroDate(p.agreementSignedAt) : false,
    agreementSignedAt: p.agreementSignedAt ? new Date(p.agreementSignedAt) : null,
  }))
